import { classNamesExtended } from "@/helpers/common/classNames";
import { convertLetters } from "@/utils/letterConversion";
import { Link, useLocation } from "react-router-dom";

const tabs = [
    { label: "Lifetime", path: "/dashboard/leaderboards/lifetime" },
    { label: "Seasons", path: "/dashboard/leaderboards/seasons" },
    { label: "By Clan", path: "/dashboard/leaderboards/clans" },
];

export const LeaderboardNav: React.FC = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
            {tabs.map((tab) => {
                const isActive = currentPath === tab.path;
                return (
                    <Link key={tab.path} to={tab.path}>
                        <span
                            className={classNamesExtended(
                                "font-prviking block cursor-pointer rounded-lg border px-4 py-2 text-center text-sm transition-colors sm:text-base",
                                isActive
                                    ? "bg-brand border-brand text-brand_charcoal"
                                    : "hover:border-brand hover:text-brand border-zinc-700 bg-zinc-950/70 text-zinc-200",
                            )}
                        >
                            {convertLetters(tab.label)}
                        </span>
                    </Link>
                );
            })}
        </div>
    );
};
